export default __webpack_public_path__ + "static/media/thirdPartyPlatform.ce98bc30.jpg";